export default __webpack_public_path__ + "static/pv-rich-3afab86deb3651787fbd154e9f8b235d.jpg";